module.exports = __webpack_public_path__ + "img/partner3.9c9a4525.jpg";